import styled from 'styled-components';

export const OnboardingTutorialMainWrapperStyled = styled.div`
    height: 480px;
    display: flex;
    font-size: 16px;
    align-items: end;
    justify-content: center;
    width: 100%;
    padding-bottom: 32px;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
    ${({ background }) => !!background && `background-image: url(${background})` };
    
    @media (max-width: 350px) {
        background-size: 270px;
        height: 380px;
    }
`;

export const OnboardingTutorialMainWrapperContainerStyled = styled.div`
    margin: 0 auto;
    max-width: ${({ contentContainerMaxWidth }) => contentContainerMaxWidth};
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
        text-align: center;
    }
    @media (max-width: 350px) {
        max-width: unset;
        padding: 0 16px;
        p {
            font-size: 14px;
        }
    }
`;
